<ng-container [formGroup]="shipment.shipmentForm">
   <ng-container *ngIf="calculator">
      <mat-expansion-panel #calculatorPanel id="calculator" class="bordered" formArrayName="calculator" [class.invalid]="(shipment.highlightInvalid$ | async) && calculator.invalid">
         <mat-expansion-panel-header>
            <mat-panel-title id="calculatorPanelTitle">Item Calculator</mat-panel-title>
         </mat-expansion-panel-header>

         <calculator-items [items]="calculator"></calculator-items>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="calculatorPanel.expanded" class="bordered">
         <mat-expansion-panel-header>
            <mat-panel-title id="itemTotalsPanelTitle">Item Totals</mat-panel-title>
         </mat-expansion-panel-header>

         <div class="item-totals" *ngIf="itemTotals != null">
            <div>
               <div id="totalPiecesLabel" class="overline">Total Pieces</div>
               <div id="totalPieces">{{ itemTotals.pieces | number}}</div>
            </div>
            <div>
               <div id="totalWeightLabel" class="overline">Total Weight</div>
               <div id="totalWeight">{{ itemTotals.totalWeight }}</div>
            </div>
            <div>
               <div id="totalVolumeLabel" class="overline">Volume Weight</div>
               <div id="totalVolume">{{ itemTotals.totalVolume }}
               </div>
            </div>
         </div>
      </mat-expansion-panel>
   </ng-container>
</ng-container>
